import React, { FC } from 'react';
import { AllieText } from '../../../components/Text';
import { AllieWifiOffPageIcon } from '../../../styling/icons/Icons';
import { AllieButton } from '../../../components';
import {
  ErrorPageContainer,
  IconWrapper,
  TextContainer,
  ButtonContainer,
} from './ConnectionErrorPage.MobileApp.styles';

export interface ConnectionErrorPageProps {
  title: string;
  subtitle: string;
  retryButtonText: string;
  onRetry: () => void;
  isRetrying?: boolean;
}

/**
 * Connection Error Page component for full-page network error states
 * Used in Alerts view
 * Based on Mockup 1
 */
export const ConnectionErrorPageMobileApp: FC<ConnectionErrorPageProps> = ({
  title,
  subtitle,
  retryButtonText,
  onRetry,
  isRetrying = false,
}) => {
  return (
    <ErrorPageContainer>
      <IconWrapper>
        <AllieWifiOffPageIcon 
          allieColor="neutral-90" 
          style={{ width: '80px', height: '80px' }} 
        />
      </IconWrapper>
      
      <TextContainer>
        <AllieText type="h3" weight={600} color="neutral-90">
          {title}
        </AllieText>
        <AllieText type="body1" weight={400} color="neutral-70">
          {subtitle}
        </AllieText>
      </TextContainer>

      <ButtonContainer>
        <AllieButton
          onclick={onRetry}
          allieType="subtle"
          allieColor="neutral"
          allieSize="small"
          corner="rounded-edges-plus"
          loading={isRetrying}
        >
          {retryButtonText}
        </AllieButton>
      </ButtonContainer>
    </ErrorPageContainer>
  );
};
